import type { FC, ReactNode } from 'react'

import { ArrowRight, Heart } from 'lucide-react'
import { buttonStyles } from '@/lib/button-styles'
import Confetti, { BAND_CONFETTI } from '@/components/landing/confetti'
import { navLinks } from '@/constants/site'
import { invitation } from '@/constants/invitation'

const SiteFooter: FC = (): ReactNode => {
    const { honoree, age, date, time } = invitation

    return (
        <footer className='relative isolate overflow-hidden bg-foreground text-background'>
            <Confetti pieces={BAND_CONFETTI} className='-z-10 opacity-70' />

            <div className='mx-auto max-w-6xl px-5 py-20 sm:px-8 sm:py-24'>
                <div className='flex flex-col items-start justify-between gap-12 md:flex-row md:items-end'>
                    <div>
                        <p className='font-heading text-5xl leading-none tracking-tight italic sm:text-7xl'>
                            À très vite !
                        </p>

                        <p className='mt-5 max-w-md text-lg leading-relaxed text-background/75'>
                            Rendez-vous le {date.full.toLowerCase()} à {time.start}. J’ai hâte de fêter ça avec vous.
                        </p>

                        <a href='/#rsvp' className={buttonStyles({ variant: 'light', size: 'lg', className: 'mt-8' })}>
                            Confirmer ma présence
                            <ArrowRight aria-hidden='true' />
                        </a>
                    </div>

                    <nav aria-label='Liens du pied de page'>
                        <ul className='grid grid-cols-2 gap-x-10 gap-y-3 text-sm font-medium'>
                            {[...navLinks, { href: '/#rsvp', label: "Répondre" }].map(link => (
                                <li key={link.href}>
                                    <a
                                        href={link.href}
                                        className='rounded-sm text-background/75 transition-colors outline-none hover:text-background focus-visible:ring-[3px] focus-visible:ring-festive-saffron/60'
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                </div>

                <div className='mt-16 flex flex-col gap-3 border-t border-background/15 pt-8 text-sm text-background/60 sm:flex-row sm:items-center sm:justify-between'>
                    <p>
                        Les {age} ans de {honoree} · {date.full}
                    </p>

                    <p className='flex items-center gap-1.5'>
                        Préparé avec
                        <Heart className='size-4 fill-current text-festive-raspberry' aria-hidden='true' />
                        <span className='sr-only'>amour</span>
                        pour l’occasion
                    </p>
                </div>
            </div>
        </footer>
    )
}

export default SiteFooter
